import React, { useEffect, useState } from "react";
import { Card, Flex, Button, Typography, InputNumber } from 'antd';
import "./IngredientCard.css";
import Calculator from "./Calculator";
import common_axios from "./../../commonAxios";

const { Text, Link } = Typography;

const IngredientCard = (props) => {
    const [number, setNumber] = useState(props.amount);
    const [inputNumber, setInputNumber] = useState(0);

    const changeAmount = (num) => {
        common_axios.put(`${process.env.REACT_APP_API_URL}/IngredientToUser/update`, {
            name: props.name,
            amount: num,
            userId: localStorage.getItem("userid")
        }).then(respone => {
            setNumber(respone.data.amount);
            props.changeMethod();
        })
    }

    return (
        <Flex gap="middle" className="flexBox" >
            <div className="nameDiv" >
                <Text className="nameIngredient" >
                    {props.name}
                </Text>
            </div>
            <div className="amountDiv">
                <Text className="amount" >
                    {number}
                </Text>
                <Button id="addButton1" className="b1" variant="solid" size="small" onClick={() => { changeAmount(inputNumber); setInputNumber(0); }}>
                    +
                </Button>
                <InputNumber className="inputNumber" min={1} value={inputNumber} defaultValue={0} onChange={setInputNumber} />
                <Button id="subtractButton1" className="b2" variant="solid" size="small" onClick={() => { changeAmount(-inputNumber); setInputNumber(0); }}>
                    -
                </Button>
            </div>
        </Flex>
    );
};

export default IngredientCard;